/* istanbul ignore file */
/** tested with integration tests */
import React from 'react';

const useHeadless = ({ isEnabled = true }) => {
    React.useLayoutEffect(() => {
        if (isEnabled) {
            const { body } = document;

            if (!body.classList.contains('headless')) {
                body.classList.add('headless');
            }
        }
    });
};

export { useHeadless };
